import { NTDefect, NTDefectService } from "@nt-portal/server-sdk";
import { ControllerOptions, DataController } from "../../../types";
import { BaseClientService } from "../base-client.service";


export interface NTDefectOptions extends ControllerOptions<NTDefect> {
   
}

export const initializeNTDefect = () => {
    let tr: NTDefect = {
        title: "",
        body: "",
        url: "",
        user: {id: "", name: "", email: "" , userName: "", roles: [], permissions: []},
        timestamp: new Date(),
        status: "new"
    }
    return tr;
}

export class ClientNTDefectService extends BaseClientService implements DataController<NTDefect> {

    private _service: NTDefectService;

    constructor() {
        super()
        this._service = new NTDefectService({
            apiService: this.apiService,
            url: this.settings.fabrixServer
        });
    }
  

    public async get(options: NTDefectOptions) {
        let fetchParams = this.buildFetchParams(options)
        return await this._service.get(fetchParams, this.token, options.filter);
    }



    public async getById(options: NTDefectOptions) {
        if (options.id)
            return await this._service.getById(options.id, this.token);
        return null
    }


    public async add(options: NTDefectOptions) {
        if (options.item)
            return await this._service.add(options.item, this.token);
        return null;
    }

    public async update(options: NTDefectOptions) {
        if (options.item)
            return await this._service.update(options.item, this.token);
        return null;
    }


    public async delete(options: NTDefectOptions) {
        if (options.id)
            return await this._service.delete(options.id, this.token);
    }


}
